import { call, put } from 'redux-saga/effects';
import { ListingsAsyncActions } from 'store/actions/listings';
import { apiCall } from 'utils/apiCall';

function* fetchAISummary(action) {
  const {
    FetchAISummary: {
      Actions: { SUCCESS, FAILURE },
    },
  } = ListingsAsyncActions;
  const {
    payload: { listingId },
  } = action;

  try {
    const response = yield call(apiCall, '/listings/conversation', 'post', {
      prompt:
        'You are a certified real estate agent asked to compare offers from potential buyers for your client. Compare the following offers across the terms and contingencies details of the offers, displaying the details in a table. Refer to the offers by the name of the primary buyer. Finish with summarizing the key differences and which offer is the best for the seller. Format the response with html tags to have it formatted ready to display in a html page',
      listingId,
    });
    yield put(SUCCESS(response.data));
  } catch (error) {
    yield put(FAILURE(error));
  }
}

export default fetchAISummary;
